import './Gift.css';
import { useState } from "react";

function Gift({ gift, handleReserveClick, handleUndoClick }) {
    const [count, setCount] = useState(1);

    const increment = () => {
        if (count < gift.remaining) {
            setCount(count + 1);
        }
    };

    const decrement = () => {
        if (count > 1) {
            setCount(count - 1);
        }
    };

    const hasReservations = () => {
        return gift.total_quantity !== gift.remaining;
    }

    const isDepleted = () => {
        return gift.remaining === 0;
    }

    return (<div className='reservation-container'>
        <div className='reserve-line' />
        <div className='reserve-row'>
            <div className='reserve-item item1 reserve-image'>
                <img src={`reserve/${gift.image_name}.png`} alt={gift.image_name} />
            </div>
            <div className={`reserve-item item2 home-text ${isDepleted() ? 'text-red': ''}`}>{`${hasReservations() ? 'Antal Kvar' : 'Önskat Antal'}: ${gift.remaining}`}</div>
            <a className={`reserve-item item3 home-text ${isDepleted() ? 'reserve-link-disabled' : ''}`} href={gift.link}>{gift.gift_name}</a>
            <div className='reserve-item item4 home-text'>Pris: ~{gift.price}:-</div>
            <div className='reserve-item item5 reserve-increment'>
                <button className={`reserve-button ${isDepleted() ? 'reserve-button-disabled' : ''}`} onClick={increment}>+</button>
                <button className={`reserve-button ${isDepleted() ? 'reserve-button-disabled' : ''}`} onClick={decrement}>-</button>
                <div>Antal:</div>
                <div>{count}</div>
            </div>
            <div className='reserve-item item6 reserve-undo-container'>
                <button
                    className={`reserve-button ${isDepleted() ? 'reserve-button-disabled' : ''}`}
                    onClick={() => handleReserveClick(gift, count)}
                >✔</button>
                {hasReservations() && <button
                    className={`reserve-button ${!hasReservations() ? 'reserve-button-disabled' : ''}`}
                    onClick={() => handleUndoClick(gift)}
                >⎌</button>}
            </div>
        </div>
    </div>)
}

export default Gift;
